<template>
	<span class="chat-card-message">
		<el-card :body-style="{ padding: '0px' }">
			<img v-if="keys != 'imSend'" :src="data.attachment.fileurl" class="image" alt="图片异常" />
			<img :src="data.news.picurl" alt="图片异常" v-else>
			<div style="padding: 14px;">
				<span class="title">{{keys == 'imSend' ? data.news.title : data.name }}</span>
				<div class="bottom clearfix">
					<span class="description">{{keys == 'imSend'?data.news.description : data.content }}</span>
					<a :href="keys == 'imSend' ? data.news.newsurl : data.attachment.newsurl " target="_blank">查看更多</a>
				</div>
			</div>
		</el-card>
	</span>
</template>
<script>
	export default {
		props:{
			data:{
				required:true
			},
			keys:{
				default:'imSend'
			},
		}
	}
</script>
<style scoped lang="scss">
	.chat-card-message {
		width: 220px;
		font-size: 14px;
		color: #838A9D;
		padding: 8px;
		// background-color: #f6f7f9;
		border-radius: 4px;

		img {
			height: 100px;
			margin: 5px auto;
			object-fit: contain;
			display: block;

		}

		.title {
			a {
				float: right;
				color: #0F81FB;
			}

		}

		.bottom {
			display: flex;
			justify-content: space-between;
			margin-top: 5px;

			.description {
				width: 50%;
				text-align: left;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			a {
				display: inline-block;
				width: 50%;
				color: #0F81FB;
				text-align: right;
			}
		}
	}
</style>
